import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { useCurrency } from "../../../intl";
import {
  DEFAULT_DEALER_REPORT_RANGE,
  trackDealerPerformanceEvent,
} from "../../../constants/automapDealerPerformanceConstants";
import { useDealerPortalIntl } from "../../../hooks/useDealerPortalIntl";
import { fetchDealerListingPerformance } from "../../../services/automapDealerPerformanceApi";
import { DealerReportsNav, ReportPageHeader } from "./DealerPerformanceShared";

export default function DealerListingPerformancePage() {
  const { dealerId } = useOutletContext();
  const { formatMoney } = useCurrency();
  const { t, formatListingAction, translateError } = useDealerPortalIntl();
  const [range, setRange] = useState(DEFAULT_DEALER_REPORT_RANGE);
  const [sort, setSort] = useState("most_views");
  const [status, setStatus] = useState("");
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    trackDealerPerformanceEvent("dealer_listing_performance_viewed", { dealerId, range });
  }, [dealerId, range]);

  useEffect(() => {
    setLoading(true);
    setError("");
    fetchDealerListingPerformance(dealerId, { range, sort, status: status || undefined })
      .then((data) => setListings(data.listings || []))
      .catch((err) => setError(translateError(err.message, "loadReports")))
      .finally(() => setLoading(false));
  }, [dealerId, range, sort, status]);

  return (
    <div className="dealer-reports">
      <DealerReportsNav active="rendimiento" />
      <ReportPageHeader
        title={t("reports.listingPerformance")}
        description={t("reports.listingPerformanceDesc")}
        dealerId={dealerId}
        range={range}
        onRangeChange={setRange}
      />
      <div className="dealer-inventory-toolbar">
        <label>
          Ordenar
          <select value={sort} onChange={(e) => setSort(e.target.value)}>
            <option value="most_views">Más vistas</option>
            <option value="most_leads">Más leads</option>
            <option value="most_whatsapp">Más WhatsApp</option>
            <option value="lowest_quality">Menor calidad</option>
            <option value="highest_risk">Mayor riesgo</option>
            <option value="oldest_confirmation">Confirmación más antigua</option>
          </select>
        </label>
        <label>
          Estado
          <select value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="">Todos</option>
            <option value="active">Activo</option>
            <option value="draft">Borrador</option>
            <option value="paused">Pausado</option>
            <option value="sold">Vendido</option>
          </select>
        </label>
      </div>
      {loading ? <p className="dealer-state-box">{t("reports.loading")}</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}
      {!loading && !error ? (
        <section className="dealer-state-box">
          <table className="dealer-inventory-table">
            <thead>
              <tr>
                <th>Vehículo</th>
                <th>Estado</th>
                <th>Precio</th>
                <th>Ciudad</th>
                <th>Vistas</th>
                <th>WhatsApp</th>
                <th>Leads</th>
                <th>Calidad</th>
                <th>Riesgo</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              {listings.length === 0 ? (
                <tr>
                  <td colSpan={10}>No hay publicaciones en este periodo.</td>
                </tr>
              ) : (
                listings.map((row) => (
                  <tr key={row.listingId}>
                    <td>{row.vehicle}</td>
                    <td>{row.status}</td>
                    <td>{formatMoney(row.priceCop)}</td>
                    <td>{row.city || "—"}</td>
                    <td>{row.listingViews}</td>
                    <td>{row.whatsappClicks}</td>
                    <td>{row.leads}</td>
                    <td>{row.qualityScore ?? "—"}</td>
                    <td>{row.riskLevel || "—"}</td>
                    <td>
                      {row.suggestedAction ? (
                        <Link to={`/v/automap/dealer/inventario/${row.listingId}`}>
                          {formatListingAction(row.suggestedAction) || row.suggestedAction}
                        </Link>
                      ) : (
                        "—"
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </section>
      ) : null}
    </div>
  );
}
